export default __webpack_public_path__ + "static/zenith-5-8b2a61f0901ff29cb240290bd9249ce5.jpg";